
/* eslint-disable */
import React from 'react';
import styles from './ComplianceTable.module.css';

const ComplianceTable = ({ data = [] }) => {
  const getStatusBadgeClass = (status) => {
    return status === "Completed" ? styles.statusCompleted : styles.statusPending;
  };

  return (
    <div className={styles.tableContainer}>
      <div className={styles.tableCard}>
        <div className={styles.tableWrapper}>
          <table className={styles.table}>
            <thead>
              <tr className={styles.headerRow}>
                <th className={styles.headerCell}>Parameter</th>
                <th className={`${styles.headerCell} ${styles.centerAlign}`}>Year</th>
                <th className={`${styles.headerCell} ${styles.centerAlign}`}>Status</th>
                <th className={styles.headerCell}>Remarks</th>
              </tr>
            </thead>
            <tbody className={styles.tableBody}>
              {data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index} className={styles.dataRow}>
                    <td className={styles.dataCell}>
                      <div className={styles.parameterTitle}>{item.parameter}</div>
                    </td>
                    <td className={`${styles.dataCell} ${styles.centerAlign}`}>
                      <span className={styles.yearBadge}>{item.year}</span>
                    </td>
                    <td className={`${styles.dataCell} ${styles.centerAlign}`}>
                      <span className={getStatusBadgeClass(item.status)}>
                        {item.status}
                      </span>
                    </td>
                    <td className={styles.dataCell}>
                      <div className={styles.remarksCell}>
                        {item.remarks.includes(',') ? (
                          <div className={styles.remarksList}>
                            {item.remarks.split(', ').map((remark, idx) => (
                              <div key={idx} className={styles.remarkItem}>
                                {remark}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className={styles.remarkItem}>{item.remarks}</div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center" }}>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ComplianceTable;
